//import { TimeSlot } from "../ShowTimeSlots";
import axios, { AxiosError } from "axios";
import { type } from "os";


type InputsFromForm = {
    //email: string,
    name: string,
    //lastName: string,
    phone: number,
    //GDPR: boolean
    occupationalMedicalCheckUp: boolean,
    reasonForVisit: string
}


export type CreateResponse = {
    success: boolean,
    message: string
}

export type ApiResponse<TData> = {
    result: TData,
    success: boolean,
    message: string
}

type ApiResult<TData> = {
    result: TData,
    errorMessage?: string
}
export type AvailableTimeSlot = {
    hourFrom: string,
    minuteFrom: string,
    hourTo: string,
    minuteTo: string,
}

const initialURL = process.env.REACT_APP_JETVEO_API_BASE_URL!;
const apiKey = process.env.REACT_APP_JETVEO_API_KEY!;

// const initialURL = "https://fba1b1b2-108a-4a56-84bb-11a132e318f5.eu.jetveo.io";
// const apiKey = "5znmnT3SWA3PyGoWet1it4Ff3A7L7uY1";


export class ApiClient {

    public static async getAvailableDays(from: Date, to: Date): Promise<ApiResult<Date[]>> {
        try {
            const res = await axios.post<ApiResponse<Date[]>>(initialURL + '/api/getavailabledates',
                {
                    DateFrom: getDateForApi(from),
                    DateTo: getDateForApi(to),
                },
                {
                    headers: { 'jv-api-key': apiKey }
                }
            );
            //TODO osetrit res status a res.data.success !!!!!!!!!!!!!!!!!!!!
            //console.log(res);
            return { result: res.data.result.map(r => new Date(r)) };

        }
        catch (error: unknown | AxiosError) {
            if (axios.isAxiosError(error)) {
                const err = error as AxiosError

                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(err.response?.status);
                console.log(err.response?.headers);
                console.log(err.message);
                console.error(error);
                return { errorMessage: err.message, result: [] };
            } else {
                return { errorMessage: (error as any)?.message, result: [] };
            }
        }
    }

    public static async getAvailableTimeSlots(selectedDate: Date): Promise<ApiResult<AvailableTimeSlot[]>> {
        try {
            const res = await axios.post<ApiResponse<AvailableTimeSlot[]>>(initialURL + '/api/getavailabletimeslots',
                {
                    SelectedDay: getDateForApi(selectedDate)
                },
                {
                    headers: { 'jv-api-key': apiKey }
                }
            )
            return { result: res.data.result };
        }
        catch (error: unknown | AxiosError) {
            if (axios.isAxiosError(error)) {
                const err = error as AxiosError

                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(err.response?.status);
                console.log(err.response?.headers);
                console.log(err.message);
                console.error(error);
                return { errorMessage: err.message, result: [] };
            } else {
                return { errorMessage: (error as any)?.message, result: [] };
            }
        }
    }

    public static async sendNewReservation(formData: InputsFromForm, selectedDate: Date, selectedTimeSlot: AvailableTimeSlot): Promise<ApiResult<string>> {
        try {
            const res = await axios.post<ApiResponse<string>>(initialURL + '/api/createnewreservation',
                {
                    Datum: getDateForApi(selectedDate),
                    //PacientJmeno: `${formData.firstName} ${formData.lastName}`,
                    PacientJmeno: `${formData.name}`,
                    //PacientEmail: formData.email,
                    PacientTelefon: formData.phone,
                    DuvodNavstevy: formData.reasonForVisit,
                    PracovneLekarskaProhlidka: formData.occupationalMedicalCheckUp,
                    HodinaOd: selectedTimeSlot.hourFrom,
                    MinutaOd: selectedTimeSlot.minuteFrom,
                    HodinaDo: selectedTimeSlot.hourTo,
                    MinutaDo: selectedTimeSlot.minuteTo
                },
                {
                    headers: { 'jv-api-key': apiKey }
                }
            )
            //console.log(res.data.result);
            // console.log(res.data.message);
            // console.log(res.data.success);
            return { result: res.data.result }
        }
        catch (error: unknown | AxiosError) {
            if (axios.isAxiosError(error)) {
                const err = error as AxiosError

                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                console.log(err.response?.status);
                console.log(err.response?.headers);
                console.log(err.message);
                console.error(error);
                return { errorMessage: err.message, result: '' };
            } else {
                return { errorMessage: (error as any)?.message, result: '' };
            }
        }
    }

}

function getDateForApi(date: Date): string {
    return `${date.getFullYear()}-${addLeadingZero(date.getMonth() + 1)}-${addLeadingZero(date.getDate())}`;

}
function addLeadingZero(number: number): string {
    const value = number.toString();
    if (value.length < 2) {
        return "0" + value;
    }
    return value;
}

(window as any).testDate = getDateForApi;